import type {Recipe} from './types';

export const focacciaInPadella: Recipe = {
    id: 26,
    key: "focacciaInPadella",
    pictures: [
        {index: 0, url: "https://www.tavolartegusto.it/wp/wp-content/uploads/2015/04/Focaccia-in-padella-Ricetta-Focaccia-in-padella.jpg"},
    ],
    video: "https://www.youtube.com/shorts/0NxNKzMVEH8",
    i18n: {
        IT: {
            title: "Focaccia in padella",
            servings: "1 focaccia da 24-26 cm",
            ingredients: [
                "300g di farina 00",
                "160g di acqua",
                "15g di olio e.v.o.",
                "5g di sale",
                "6g di lievito chimico istantaneo per torte salate",
                "150g di prosciutto cotto",
                "100g di formaggio a scelta (io ho scelto il taleggio)",
            ],
            steps: [
                "In una ciotola combiniamo la farina, il sale ed il lievito. Mescoliamo bene, quindi uniamo l'acqua e l'olio. Cominciamo ad impastare prima in ciotola, poi sulla spianatoia, giusto il tempo necessario per far assorbire tutta la farina. L'impasto risulterà morbido, ma non appiccicoso. Dividiamo quindi il panetto in due e lasciamolo riposare coperto per 10 min sulla spianatoia infarinata.",
                "Stendiamo ciascuna metà ad uno spessore di 3mm, aiutandoci con abbondante semola. Prendiamo quindi una padella dal diametro di 24-26 cm, ungiamola per bene e spolverizziamola con altra semola. Adagiamo il primo disco di pasta, facendolo cadere anche sui bordi della padella. Procediamo quindi a farcire con il ripieno scelto, copriamo con il secondo disco, facendolo ben aderire al primo ed eliminando la pasta in eccesso se necessario. Pizzichiamo e ripieghiamo i bordi su se stessi.",
                "Poniamo quindi sul fuoco a fiamma dolce e cuociamo il primo lato per 5-7 min, coprendo con un coperchio.",
                "Prima di girare la focaccia, spolverizziamo con ulteriore semola e uniamo ancora un filo d'olio. Giriamo la focaccia e cuociamo ancora 5 min, sempre coperta.",
                "Serviamola immediatamente, ancora fumante!",
            ],
        },
        EN: {
            title: "Pan Focaccia",
            servings: "1 focaccia, 24-26 cm",
            ingredients: [
                "300g of type 00 flour",
                "160g of water",
                "15g of extra virgin olive oil",
                "5g of salt",
                "6g of instant baking powder for savoury bakes",
                "150g of cooked ham",
                "100g of cheese of your choice (I chose taleggio)",
            ],
            steps: [
                "In a bowl combine the flour, the salt and the baking powder. Mix well, then add the water and the oil. Start kneading in the bowl first, then on the work surface, just long enough for all the flour to be absorbed. The dough will be soft, but not sticky. Divide the dough into two and let it rest covered for 10 min on the floured work surface.",
                "Roll out each half to a thickness of 3mm, using plenty of semolina. Take a pan 24-26 cm in diameter, grease it well and dust it with more semolina. Lay down the first disc of dough, letting it fall over the edges of the pan as well. Then fill with the chosen filling, cover with the second disc, pressing it firmly onto the first and trimming off the excess dough if necessary. Pinch and fold the edges over themselves.",
                "Then place it on the stove over a gentle flame and cook the first side for 5-7 min, covering with a lid.",
                "Before turning the focaccia, dust it with more semolina and add another drizzle of oil. Turn the focaccia and cook for another 5 min, still covered.",
                "Serve it immediately, still steaming hot!",
            ],
        },
        PL: {
            title: "Focaccia z patelni",
            servings: "1 focaccia o średnicy 24-26 cm",
            ingredients: [
                "300g mąki typu 00",
                "160g wody",
                "15g oliwy z oliwek extra vergine",
                "5g soli",
                "6g proszku do pieczenia do wytrawnych wypieków",
                "150g szynki gotowanej",
                "100g wybranego sera (ja wybrałem taleggio)",
            ],
            steps: [
                "W misce łączymy mąkę, sól i proszek do pieczenia. Dobrze mieszamy, następnie dodajemy wodę i oliwę. Zaczynamy wyrabiać najpierw w misce, potem na stolnicy, tylko tyle czasu, ile potrzeba, aby cała mąka została wchłonięta. Ciasto będzie miękkie, ale nie klejące. Dzielimy je na dwie części i zostawiamy przykryte na 10 min na oprószonej mąką stolnicy.",
                "Rozwałkowujemy każdą połowę na grubość 3mm, pomagając sobie obfitą ilością semoliny. Bierzemy patelnię o średnicy 24-26 cm, dobrze ją smarujemy i oprószamy kolejną porcją semoliny. Układamy pierwszy krążek ciasta, pozwalając mu opaść również na brzegi patelni. Następnie nakładamy wybrane nadzienie, przykrywamy drugim krążkiem, dobrze dociskając go do pierwszego i usuwając nadmiar ciasta, jeśli to konieczne. Zaszczypujemy i zawijamy brzegi do środka.",
                "Stawiamy następnie na małym ogniu i smażymy pierwszą stronę przez 5-7 min, przykrywając pokrywką.",
                "Przed obróceniem focacci oprószamy ją kolejną porcją semoliny i dodajemy jeszcze odrobinę oliwy. Obracamy focaccię i smażymy jeszcze 5 min, nadal pod przykryciem.",
                "Podajemy natychmiast, jeszcze parującą!",
            ],
        },
    },
};
